// import { ReactComponent as CheckBig } from '../../../assets/svg/checkBig.svg';
import React, { useState } from 'react';

import { Button, Row } from 'react-bootstrap';

import AboutYourself from './AboutYourself';
import Begin from './Begin';
import CustomizeYourWorkspace from './CustomizeYourWorkspace';
import DwellLogo from '../../../common/components/DwellLogo';
import Loader from '../../../common/components/Loader';
import history from '../../../routes/history';
import { DWELLINGS } from '../../dwelling/routes';
import { PropsFromReduxRegister } from '../containers/RegisterContainer.js';

const RegisterComponent = (props: PropsFromReduxRegister) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [validatedBegin, setValidatedBegin] = useState(false);
  const [validatedWorkspace, setValidatedWorkspace] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [estimatedPropertyNumber, setEstimatedPropertyNumber] = useState('');  
  const [managerType, setManagerType] = useState('');  
  const [companyName, setCompanyName] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSmsModal, setShowSmsModal] = useState(false);
  const [siren, setSiren] = useState('');

  const handleSubmitBegin = (event: any) => {
    event.preventDefault();
    setError('');
    setValidatedBegin(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    setLoading(true);
    props
      .emailExists(form.email.value)
      .then((result) => {
        if (!result) {
          setEmail(form.email.value);
          setPassword(form.password.value);
          setStep(2);
        } else {
          setError('Un compte avec cette adresse email existe déjà');
        }
      })
      .catch(() => setError("Problème lors de la recherche de l'email"));
    setLoading(false);
  };

  const handleSubmitAbout = (firstname: string, name: string, phone: string) => {
    setError('');
    setLoading(true);
    if (phone.match(/^\+\d*$/)) {
      props
        .companyExists(siren)
        .then((result: any) => {
          if (!result) {
            props
              .register(email, password, phone, name, firstname)
              .then(() => {
                setLoading(false);
                setShowSmsModal(true);
              })
              .catch(() => handleError("Problème lors de l'inscription"));
          } else handleError('Un compte lié à cette société existe déjà');
        })
        .catch(() => handleError('Problème lors de la recherche de la société'));
    } else setError('Le numéro de téléphone doit être au format +33');
    setLoading(false);
  };

  const handleSubmitWorkspace = (event: any) => {
    event.preventDefault();
    setValidatedWorkspace(true);
    const form = event.currentTarget;
    if (form.checkValidity() !== false) {
      props
        .createCompany({
          siren,
          name: companyName,
          type: managerType,
          property_in_management: estimatedPropertyNumber
        })
        .then((_societyID: string) => {
          setStep(4);
        })
        .catch(() => {
          setError('Problème lors de la création de la société');
        });
    }
  };

  const handleStart = () => {
    props.setIsLogged(true);
    history.push(DWELLINGS);
  };

  const handleError = (error: string) => {
    setError(error);
    setLoading(false);
  };

  const ThankYou = () => {
    return (
      <Row className="align-items-center justify-content-center register-form">
        {/*<Finger3 />*/}
        <div className="  d-flex flew-row justify-content-between register-title text-center mb-5 thankYouTitle align-items-center">
          {/*<CheckBig />*/} Merci !
        </div>
        <p className="fw-normal text-center thankYouText ">
          Vous avez reçu un mail de confirmation pour valider votre compte.
        </p>

        <p className="fw-bold text-center thankYouText mb-0">Ajoutez votre premier bien</p>
        <p className="fw-bold text-center thankYouText px-0">et démarrez votre premier état des lieux</p>
        <Button className="mt-4 fw-bold btn-register" onClick={handleStart}>
          Démarrer mon premier état des lieux
        </Button>
      </Row>
    );
  };

  const handleStep = () => {
    switch (step) {
      case 1:
        return (
          <Begin
            error={error}
            handleSubmitBegin={handleSubmitBegin}
            validatedBegin={validatedBegin}
            setValidatedBegin={setValidatedBegin}
            passwordVisibility={passwordVisibility}
            setPasswordVisibility={setPasswordVisibility}
          />
        );
      case 2:
        return (
          <AboutYourself
            error={error}
            companyExists={props.companyExists}
            getCompanyInfos={props.getCompanyInfos}
            setStep={setStep}
            handleSubmitAbout={handleSubmitAbout}
            showSmsModal={showSmsModal}
            setShowSmsModal={setShowSmsModal}
            verifyPhoneNumber={props.verifyPhoneNumber}
            siren={siren}
            setSiren={setSiren}
          />
        );
      case 3:
        return (
          <CustomizeYourWorkspace
            error={error}
            companyName={companyName}
            setCompanyName={setCompanyName}
            handleSubmitWorkspace={handleSubmitWorkspace}
            validatedWorkspace={validatedWorkspace}
            setValidatedWorkspace={setValidatedWorkspace}
            setManagerType={setManagerType}
            setEstimatedPropertyNumber={setEstimatedPropertyNumber}
          />
        );
      case 4:
        return <ThankYou />;
    }
  };

  return (
    <>
      <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center flex-wrap">
        {loading ? <Loader /> : <>{handleStep()}</>}
        <div className="position-absolute top-0 start-0 p-3">
          <DwellLogo linkTo="/login" />
        </div>
      </div>
    </>
  );
};

export default RegisterComponent;
